// extracted by mini-css-extract-plugin
export var footer = "_mj-0";
export var inherit = "_mj-1";
export var input = "_mj-2";
export var modalContent = "_mj-3";
export var quillEditor = "_mj-4";
export var subtitle = "_mj-5";